// @wc-ignore-file

/** Search params of the document page, shared by the bare `/docs/:id` redirect (CR-162). */
export interface DocSearch {
  mentionUserId?: string;
  /**
   * CR-150: id of a comment (messages.id) whose thread the page opens and selects.
   * KEEP IN SYNC with backend/api-server/src/routes/notification-email-worker.ts
   * resolveNotificationUrl, whose email link builds the same `?commentId=`.
   */
  commentId?: string;
}

export function validateDocSearch(search: Record<string, unknown>): DocSearch {
  return {
    mentionUserId: typeof search.mentionUserId === "string" ? search.mentionUserId : undefined,
    commentId: typeof search.commentId === "string" ? search.commentId : undefined,
  };
}
